import type { ReactElement } from "react";

import { Warning } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

interface IDangerZoneAction {
    text: string;
    ctaText: string;
    actionName: string;
    onCtaClick?: VoidFunction;
    children?: ReactElement | null;
}

export const DangerZoneAction = ({ text, ctaText, actionName, onCtaClick, children }: IDangerZoneAction) => {
    return (
        <Flex
            flexDirection="column"
            gap="16px"
        >
            <Flex
                alignItems="center"
                justifyContent="space-between"
                data-automation={`llm-tracker-danger-zone-${actionName}`}
                gap="16px"
            >
                <Flex gap="8px">
                    <Warning
                        size="sm"
                        color={colorsPalettes.red["400_P"]}
                    />
                    <Text
                        fontVariant="body2"
                        color={colorsPalettes.carbon[500]}
                        width="100%"
                    >
                        {text}
                    </Text>
                </Flex>
                {onCtaClick ? (
                    <Button
                        type="warningOutline"
                        width="210px"
                        onClick={onCtaClick}
                        data-automation={`llm-tracker-danger-zone-${actionName}-button`}
                    >
                        {ctaText}
                    </Button>
                ) : null}
            </Flex>
            {children}
        </Flex>
    );
};
